import { render } from "./EmployeeRejectedRequests.vue?vue&type=template&id=818d62be"
import script from "./EmployeeRejectedRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRejectedRequests.vue?vue&type=script&lang=js"

import "./EmployeeRejectedRequests.vue?vue&type=style&index=0&id=818d62be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__